<template>
  <footer class="sitefooter wave">
    <div class="container">
      <div v-if="bannerList.length > 0 " class="banner__list">
        <fragment v-for="(item, index) in bannerList" :key="index">
          <div class="banner__item" v-if="!isLoading">
            <a
              target="_blank"
              :href="item.acf?.link_url"
              :style="{
                backgroundImage: `url(${$func.formatUrl(item.acf?.btn_image)})`,
              }"
            >
              <img
                v-if="item.acf?.btn_image"
                :src="$func.formatUrl(item.acf?.btn_image)"
                alt="banner"
              />
            </a>
          </div>

          <div class="skeleton-parent" v-if="isLoading">
            <PuSkeleton style="height: 80px" :count="1" />
          </div>
        </fragment>
      </div>
      <div class="footer">
        <div class="footer__col">
          <router-link to="/">
            <img
              src="@/assets/img/footer/footer_logo.svg"
              alt="HARUMIFLAGタウンポータル"
            />
          </router-link>
          <!-- <ul class="slink__list">
            <li class="slink">
              <a target="_blank" href="https://twitter.com/intent/tweet"
                ><img src="@/assets/img/footer/si_twitter.svg" alt="twitter"
              /></a>
            </li>
            <li class="slink">
              <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u="
                ><img src="@/assets/img/footer/si_facebook.svg" alt="facebook"
              /></a>
            </li>
            <li class="slink">
              <a target="_blank" href="https://www.instagram.com/sharer.php?u="
                ><img
                  src="@/assets/img/footer/si_instagram.svg"
                  alt="instagram"
              /></a>
            </li>
          </ul>
          <p class="harumi-font pc">© HARUMI FLAG</p> -->
        </div>
        <div class="footer__col__menuholder">
          <div class="footer__col__menu">
            <ul class="menufooter">
              <li class="menufooter__item">
                <span class="harumi-font">EVENT<span>イベント</span></span>
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="/event" @click.native="scrollToTop"
                      >イベント情報</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menufooter__item">
                <span class="harumi-font custom-sp-favorite">MY FAVORITE THINGS<span>私のお気に入り</span></span>
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="/myfavoritethings" @click.native="scrollToTop"
                      >HARUMI FLAGの魅力や楽しさ発信<br>（写真投稿）</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menufooter__item">
                <span class="harumi-font">SHOP<span>ショップ</span></span>
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="/shop-guide" @click.native="scrollToTop"
                      >ショップガイド</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/shop-news" @click.native="scrollToTop"
                      >ショップニュース</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menufooter__item">
                <span class="harumi-font"
                  >ABOUT<span>HARUMI FLAGについて</span></span
                >
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="/about/concept" @click.native="scrollToTop"
                      >街中に出会いがある<br />にぎわいの街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/design" @click.native="scrollToTop"
                      >地域全体のデザインに<br />一体感のある個性的な街</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/about/location"
                      @click.native="scrollToTop"
                      >みんなで守り、<br />育てていく森の街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/eco" @click.native="scrollToTop"
                      >様々なエネルギーを<br />巧みに使いこなす街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/legacy" @click.native="scrollToTop"
                      >オリンピック・<br />パラリンピックの<br />レガシーが息づく街</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/about/facility"
                      @click.native="scrollToTop"
                      >みんなが使いこなし<br />楽しみをつなぐ街</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="footer__col__menu">
            <ul class="menufooter">
              <li class="menufooter__item">
                <span class="harumi-font">ACCESS<span>アクセス</span></span>
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li v-if="accesstList.acf?.large_title_2">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_2}`)
                      "
                      >{{ accesstList.acf?.large_title_2 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_3">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_3}`)
                      "
                      >{{ accesstList.acf?.large_title_3 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_4">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_4}`)
                      "
                      >{{ accesstList.acf?.large_title_4 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_5">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_5}`)
                      "
                      >{{ accesstList.acf?.large_title_5 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_6">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_6}`)
                      "
                      >{{ accesstList.acf?.large_title_6 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_7">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_7}`)
                      "
                      >{{ accesstList.acf?.large_title_7 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_8">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_8}`)
                      "
                      >{{ accesstList.acf?.large_title_8 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_9">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_9}`)
                      "
                      >{{ accesstList.acf?.large_title_9 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_10">
                    <a
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_10}`)
                      "
                      >{{ accesstList.acf?.large_title_10 }}</a
                    >
                  </li>
                </ul>
              </li>
              <li class="menufooter__item">
                <span class="harumi-font custom-sp"
                  >ENVIRONMENT<span>環境</span></span
                >
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="/energy" @click.native="scrollToTop"
                      >エネルギーマネジメント</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/energy-usage" @click.native="scrollToTop"
                      >エネルギーの利用状況</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/environment" @click.native="scrollToTop"
                      >環境への配慮</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="footer__col__menu">
            <!-- <ul class="menufooter">
              <li class="menufooter__item">
                <span class="harumi-font">FACILITY<span>周辺施設</span></span>
                <button class="ques_expand ico--white"></button>
                <ul class="submenu">
                  <li>
                    <router-link to="">ららテラス HARUMI FLAG</router-link>
                  </li>
                  <li><router-link to="">水素ステーション</router-link></li>
                  <li><router-link to="">晴海ふ頭公園</router-link></li>
                  <li><router-link to="">晴海小学校</router-link></li>
                  <li><router-link to="">晴海中学校</router-link></li>
                  <li><router-link to="">４丁目複合施設</router-link></li>
                  <li><router-link to="">月島警察署</router-link></li>
                  <li><router-link to="">臨港消防署</router-link></li>
                </ul>
              </li>
            </ul> -->
            <a
              href="https://mansion.harumi-flag.net/app/login"
              target="_blank"
              class="btn mt-0"
            >
              <img src="@/assets/img/top/door_link.svg" alt="" />居住者ログイン
            </a>
            <ul class="menufooter">
              <li class="menufooter__item">
                <ul class="menufooter__note">
                  <li>
                    <router-link to="/" @click.native="scrollToTop"
                      >トップ</router-link
                    >
                  </li>
                  <!-- <li>
                    <router-link to="/coming-soon" @click.native="scrollToTop"
                      >サイトのご利用について</router-link
                    >
                  </li> -->
                  <li>
                    <router-link to="/privacypolicy" @click.native="scrollToTop"
                      >個人情報保護方針</router-link
                    >
                  </li>
                  <!-- <li>
                    <router-link to="/coming-soon" @click.native="scrollToTop"
                      >個人情報のお取り扱いについて</router-link
                    >
                  </li> -->
                  <li>
                    <router-link to="/contact/form" @click.native="scrollToTop"
                      >お問い合わせ</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="coppy-right sp">
          <p class="harumi-font sp">© HARUMI FLAG</p>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
import { waveFooter } from '@/assets/js/waveFooter';
import axios from 'axios';
import { Fragment } from 'vue-fragment';
import CONSTANT from '../constant';
import { getUrl } from '@/utils/helper';

export default {
  name: 'FooterView',
  components: {
    Fragment,
  },
  mounted() {
    waveFooter();
  },
  data() {
    return {
      bannerList: [],
      accesstList: {},
      listFilter: CONSTANT.dataFilter[0],
      isLoading: true,
      isActiveCheck: '',
    };
  },
  computed: {},
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handleMoveToAccess(title) {
      if (this.$route.path === '/access') {
        var element_to_scroll_to = document.getElementById(title);
        element_to_scroll_to.scrollIntoView();
        this.isActiveCheck = title;
        Array.from(document.querySelectorAll('.access__tab__item')).forEach(
          function (el) {
            el.classList.remove('current');
          }
        );

        document.getElementById(`tab_${title}`).classList.add('current');
      } else {
        localStorage.setItem('accessKey', title);
        this.$router.push({ name: 'Access' }).catch(() => {});
      }
    },
  },
  created() {
    this.isLoading = true;
    //Access footer
    getUrl(`/access/${process.env.VUE_APP_ID_ACCESS}`)
      .then((response) => {
        this.accesstList = response.data;
        this.isLoading = false;
      })
      .catch((e) => {
        console.log(e);
        this.$router.push('/timeout');
      });
    // Banner Link
    getUrl('/banner_link')
      .then((response) => {
        var filtered = this.$func.filterByDeliveryMedia(response.data, [
          this.listFilter.town,
        ]);
        var sorted = this.$func.sortByNumberKey(filtered, 'display_order');
        this.bannerList = JSON.parse(JSON.stringify(sorted));
        this.isLoading = false;
      })
      .catch((e) => {
        console.log(e);
        // this.$router.push('/timeout')
      });
  },
};
</script>
